exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ssui-fade-enter-active,\n.ssui-fade-leave-active {\n  opacity: 1;\n  -webkit-transition: opacity linear 0.2s;\n  transition: opacity linear 0.2s;\n}\n.ssui-fade-enter,\n.ssui-fade-leave-to {\n  opacity: 0;\n}\n.ssui-slide-enter,\n.ssui-slide-leave-active {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n.ssui-slide-leave-active,\n.ssui-slide-enter-active {\n  -webkit-transition: -webkit-transform .3s;\n  transition: -webkit-transform .3s;\n  transition: transform .3s;\n  transition: transform .3s, -webkit-transform .3s;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-fa98aa2c","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@finance/ssvue/src/components/toast/index.vue
// module id = 258
// module chunks = 8